import React from "react";
import Col from "react-bootstrap/Col";

import DashboardLink from "Components/DashboardLink/DashboardLink";
import payments from "Assets/Icons/payments.svg";
import account from "Assets/Icons/account.svg";
import plus from "Assets/Icons/plus.svg";
import settings from "Assets/Icons/settings.svg";

import "./DashboardLinks.scss";
import useMode, { MODE } from "Utils/Hooks/useMode";
import useSession from "Utils/Hooks/useSession";
import { Box } from "@mui/material";

const Dashboard = () => {
  const { session } = useSession();
  const mode = useMode();

  const showDeposit = mode !== MODE.withdraw;
  const showWithdraw = mode !== MODE.deposit;
  const manageBanks = mode === MODE.manageBanks;
  const showLimit = session.toggles.limitEnabled;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: "1",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          maxWidth: { xs: "100%", md: "350px" },
        }}
      >
        {(session.transactionSucceeded || !showLimit) && <Col></Col>}
        {showDeposit && !session.transactionSucceeded && !manageBanks && (
          <DashboardLink text={"Deposit Funds"} icon={plus} link="/addFunds" />
        )}
        {showWithdraw && !session.transactionSucceeded && !manageBanks && (
          <DashboardLink
            text={"Withdraw Funds"}
            icon={payments}
            link="/withdrawFunds"
          />
        )}

        <DashboardLink
          text={"My Funding Sources"}
          icon={account}
          link="/myAccounts"
        />

        {showLimit && !manageBanks && (
          <DashboardLink
            text={"Limit Change"}
            icon={settings}
            link="/manageLimit"
          />
        )}
        {(session.transactionSucceeded || !showLimit) && <Col></Col>}
      </Box>
    </Box>
  );
};

export default Dashboard;
